<template>
<div class="chapter">
<div class="inner_page">
<p class="p3"> </p>
<p class="p4">This book is dedicated to the memory of Amber.</p>
<p class="p4">“And some there be, which have no memorial.”</p>
<p class="p3"> </p>
<p class="p3"> </p>
<p class="p3"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section3.vue?fe166b6e